
module.exports = function Toggle ($host, config) {

  var $trigger = $('[data-toggle-trigger]', $host);
  var $target  = $('[data-toggle-target]',  $host);

  $trigger.on('click', function () {
    $target.toggle();
  });

  $target.hide();

}

